// Finance module shared design tokens (2026-08-25).
//
// Every Finance page (Dashboard, Transactions, Expenses, Reports,
// Reconciliation) should read from this single palette so the whole
// area feels like one workspace instead of five independently-styled
// pages. Semantic colors are strictly reserved for their meaning:
//
//   positive/paid/credit  → mint
//   expense/debit         → rose
//   outstanding/warning   → muted gold
//   info/brand            → steel blue
//
// No dark forest green, no neon blue, no random violet, no burnt
// orange, no rainbow KPI cards.

export const fin = {
  color: {
    navy:        "#17324D",
    valueText:   "#263F55",
    blue:        "#4E78A6",
    steel:       "#6F96BE",
    softIndigo:  "#6878A6",
    muted:       "#708397",
    disabled:    "#B2BEC9",
    border:      "#DDE6EE",
    borderSoft:  "#EAF0F5",
    surfaceBlue: "#EAF2F8",
    pageBg:      "#F5F8FB",
    card:        "#FFFFFF",
    // Semantic
    success:     "#5BAA83",
    successText: "#467F66",
    successBg:   "#F1F8F4",
    danger:      "#D97882",
    dangerText:  "#B75F68",
    dangerBg:    "#FCF3F4",
    warning:     "#C9A24F",
    warningText: "#94733A",
    warningBg:   "#FBF7ED",
  },
  radius:  { sm: 10, md: 14, lg: 16, xl: 18 },
  shadow:  {
    card:      "0 6px 18px rgba(23,50,77,0.05)",
    cardHover: "0 10px 24px rgba(23,50,77,0.08)",
    header:    "0 8px 24px rgba(23,50,77,0.06)",
  },
} as const;

export type FinTone = "blue" | "steel" | "indigo" | "success" | "danger" | "warning" | "navy";

/** Icon-tile background + foreground for the muted-tone system. */
export const toneStyles = (tone: FinTone) => {
  switch (tone) {
    case "success": return { bg: fin.color.successBg, fg: fin.color.success };
    case "danger":  return { bg: fin.color.dangerBg,  fg: fin.color.danger };
    case "warning": return { bg: fin.color.warningBg, fg: fin.color.warning };
    case "steel":   return { bg: fin.color.surfaceBlue, fg: fin.color.steel };
    case "indigo":  return { bg: "#F0F2F8",          fg: fin.color.softIndigo };
    case "navy":    return { bg: "#EEF2F7",          fg: fin.color.navy };
    case "blue":
    default:        return { bg: fin.color.surfaceBlue, fg: fin.color.blue };
  }
};
